import { Badge } from "@mantine/core";

const NoShrinkBadge = ({ children, ...props }) => (
  <Badge
    {...props}
    styles={{
      label: {
        overflow: "visible",
        textOverflow: "clip",
      },
    }}
  >
    {children}
  </Badge>
);

export default NoShrinkBadge;
